import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import $ from "jquery";

import { GetItemType } from "../../../Redux/Reducers/Submitter/WPBItemType";
import {
  AddBudgetItems,
  GetBudgetItemsById,
  restValidateBudgetItems,
  UpdateBudgetItems,
  ValidateBudgetItems,
} from "../../../Redux/Reducers/ReportStage/BudgetItems";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import Swal from "sweetalert2";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

function AddEditBudgetItem(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      BudgetItems: state.BudgetItems.BudgetItems,
      loadingBudgetItems: state.loadingBudgetItems?.loadingBudgetItems,
      ItemTypeReducers: state.ItemTypeReducers.ItemType,
      BudgetItemsValidate: state.BudgetItems.BudgetItemsValidate,
    };
  });
  console.log(state.ItemTypeReducers, "rrrr");

  const BudgetItemsList = useSelector((state) => state.BudgetItems.BudgetItems);
  const ItemTypeList = useSelector((state) => state.ItemTypeReducers.ItemType);

  const [ItemTypeId, setItemTypeId] = useState(null);
  const [ItemName, setItemName] = useState(null);
  const [ItemDesecrabtion, setItemDesecrabtion] = useState(null);
  const [NumberOfunit, setNumberOfunit] = useState(null);
  const [UnitPrice, setUnitPrice] = useState(null);
  const [Total, setTotal] = useState(null);

  const [NewAddedAttachment, setNewAddedAttachment] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();

  // Function to calculate total automatically
  const calculateTotal = (units, price) => {
    const numberOfUnits = parseFloat(units || 0);
    const unitPrice = parseFloat(price || 0);
    const calculatedTotal = numberOfUnits * unitPrice;
    setTotal(calculatedTotal || 0);
  };

  // useEffect to recalculate total whenever NumberOfunit or UnitPrice changes
  useEffect(() => {
    calculateTotal(NumberOfunit, UnitPrice);
  }, [NumberOfunit, UnitPrice]);

  // Function to load configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  useEffect(() => {
    dispatch(GetItemType());
  }, []);

  const AddInfo = async () => {
    const validationList = await dispatch(
      ValidateBudgetItems({
        itemTypeId: ItemTypeId,
        itemName: ItemName,
        itemDescription: ItemDesecrabtion,
        newAdded: props.newAdded,
        numberOfUnits: NumberOfunit == "" ? null : NumberOfunit,
        unitPrice: UnitPrice == "" ? null : UnitPrice,

        newAddedAttachment: NewAddedAttachment?.name,
      })
    );
    if (validationList.payload.length === 0) {
      var formData = new FormData();
      formData.append("itemTypeId", ItemTypeId);
      formData.append("itemName", ItemName);
      formData.append("itemDescription", ItemDesecrabtion);
      formData.append("numberOfUnits", NumberOfunit);
      formData.append("unitPrice", UnitPrice);
      formData.append("newAdded", true);
      formData.append("file", NewAddedAttachment);

      formData.append(
        "total",
        parseFloat(NumberOfunit || 0) * parseFloat(UnitPrice || 0)
      );

      formData.append("newAddedAttachment", NewAddedAttachment);
      formData.append("reportId", props.reportId);
      await dispatch(AddBudgetItems(formData));

      $(".close-btn").trigger("click");

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });

      dispatch(setRefreshTable());
    }
  };
  console.log(NewAddedAttachment, "sssssdwdwdwd");

  useEffect(() => {
    dispatch(restValidateBudgetItems());
  }, []);
    console.log(props.newAdded, "sdsdsssssssssssssdsd");

  const UpdateInfo = async () => {
    const validationList = await dispatch(
      ValidateBudgetItems({
        itemTypeId: ItemTypeId,
        itemName: ItemName,
        itemDescription: ItemDesecrabtion,
        numberOfUnits: NumberOfunit == "" ? null : NumberOfunit,
        unitPrice: UnitPrice == "" ? null : UnitPrice,

        newAddedAttachment: NewAddedAttachment?.name
          ? NewAddedAttachment?.name
          : NewAddedAttachment,
      })
    );

    if (validationList.payload.length === 0) {
      var formData = new FormData();
      formData.append("BudgetItemsId", props.budgetItemsId);
      formData.append("itemTypeId", ItemTypeId);
      formData.append("itemName", ItemName);
      formData.append("itemDescription", ItemDesecrabtion);
      formData.append("numberOfUnits", NumberOfunit);
      formData.append("unitPrice", UnitPrice);
      formData.append("newAdded", props.newAdded);
      if (props.newAdded) {
        formData.append("file", NewAddedAttachment);
        formData.append(
          "newAddedAttachment",
          state.BudgetItems?.newAddedAttachment
        );
      }
      // formData.append("file", props.newAdded?NewAddedAttachment:null);
      formData.append(
        "total",
        parseFloat(NumberOfunit || 0) * parseFloat(UnitPrice || 0)
      );

      formData.append("reportId", props.reportId);
      dispatch(UpdateBudgetItems(formData));
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  console.log(dataJsonObject, "fff");

  useEffect(() => {
    if (props.canEdit == "edit") {
      dispatch(GetBudgetItemsById({ budgetItemsId: props.budgetItemsId }));
    }
  }, [props.budgetItemsId]);

  useEffect(() => {
    if (props.canEdit == "edit") {
      setItemTypeId(BudgetItemsList?.itemTypeId);
      setItemName(BudgetItemsList?.itemName);
      setItemDesecrabtion(BudgetItemsList?.itemDescription);
      setNumberOfunit(BudgetItemsList?.numberOfUnits);
      setUnitPrice(BudgetItemsList?.unitPrice);
      setNewAddedAttachment(BudgetItemsList?.newAddedAttachment);
      setTotal(BudgetItemsList?.total);
    }
  }, [BudgetItemsList]);

  console.log(props.newAdded, "sssssddsssssssssssssssssssd");

  const HTML = (
    <>
      {" "}
      <div className="AddEdite">
        <AllDropDownsAHSF
          fieldsName="ItemType"
          show={true}
          disabled={false}
          arrayOoptionList={ItemTypeList}
          KeyText={"itemName"}
          KeyValue={"itemTypeId"}
          dropdownType={"normal"}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.itemTypeId : ""
          }
          onChange={(e) => {
            setItemTypeId(e.target.value);
          }}
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("ItemType")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="ItemName"
          show={true}
          disabled={false}
          onChange={(e) => {
            setItemName(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.itemName : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("ItemName")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <TextAreaAHSF
          fieldsName="ItemDescription"
          show={true}
          disabled={false}
          onChange={(e) => {
            setItemDesecrabtion(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.itemDescription : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("ItemDescription")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="NumberOfUnits"
          show={true}
          // type={"number"}
          comma={true}
          disabled={false}
          onChange={(e) => {
            setNumberOfunit(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.numberOfUnits : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("NumberOfUnits")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="UnitPrice"
          show={true}
          comma={true}
          disabled={false}
          onChange={(e) => {
            setUnitPrice(e.target.value);
          }}
          defaultValue={
            props.canEdit == "edit" ? BudgetItemsList?.unitPrice : ""
          }
          showValidationMessage={
            state.BudgetItemsValidate
              ? state.BudgetItemsValidate.includes("UnitPrice")
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        {props.newAdded && (
          <div style={{ marginTop: "10px" }}>
            <label>
              مرفق التعديل الميزاني للبند
              <span className="star" style={{ color: "red" }}>
                *
              </span>
            </label>
            <div style={{ marginTop: "20px" }}>
              <AttachmentASFH
                id={"NewAddedAttachment"}
                title={"إضافة مرفق"}
                show={true}
                clear={false}
                AttachementType="NewAddedAttachment"
                singleFile={
                  props.canEdit == "edit"
                    ? BudgetItemsList?.newAddedAttachment
                    : ""
                }
                readOnly={false}
                onChange={(e) => {
                  setFileChange(fileChange + 1);
                  setNewAddedAttachment(e.target.files[0]);
                }}
                showValidationMessage={
                  state.BudgetItemsValidate
                    ? state.BudgetItemsValidate.includes("NewAddedAttachment")
                    : false
                }
                validationMessage="يرجى تعبئة هذا الحقل"
              />
            </div>
          </div>
        )}

        <InputAHSF
          fieldsName="Total"
          show={true}
          comma={true}
          // type={"number"}
          disabled={true}
          value={Total || 0} // Use value instead of defaultValue for controlled input
          showValidationMessage={false}
        />

        <div className="containersButton">
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                props.canEdit == "edit" ? UpdateInfo() : AddInfo();
              }}
              disabled={false}
              title={props.canEdit == "edit" ? "تعديل" : "إضافة"}
              text={props.canEdit == "edit" ? "تعديل" : "إضافة"}
              show={true}
            />
          </div>
        </div>
      </div>
    </>
  );
  return (
    <>
      {props.canEdit == "edit" ? (
        <>{BudgetItemsList?.budgetItemsId ? <>{HTML}</> : <></>}</>
      ) : (
        <>{HTML}</>
      )}
    </>
  );
}

export default AddEditBudgetItem;
